define(function(require) {
    // GEO09E70_TERRI_ANA_S_ANG_FIX layer definition config
    return {
        LAYER_ID : "GEO09E70_TERRI_ANA_S_ANG",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        USE_TYPED_ARRAY : true,
        INDEX : 2,
        DATATABLE_ID : "t_GEO09E70_TERRI_ANA_S_ANG",
        QUERY_FIELDS : ["CD_TA_SEC", "CD_CS", "NB_PE"],
        FIELDS : [
            {ID : "CD_TA_SEC", NAME : "Code", DATA_TYPE: "STRING", VALUE : "{{CD_TA_SEC}}"},
            {ID : "CD_CS", NAME : "Code de l'organisme responsable", DATA_TYPE: "STRING", VALUE : "{{CD_CS}}"},
            //from the joined table
            {ID : "NB_PE", NAME : "Nombre de places-élèves sur 10 ans (2034-2035)", DATA_TYPE : "NUMBER", DECIMAL_PLACES: 0, VALUE: "{{NB_PE}}"}
        ],
        JOIN_KEY: "TERR_ANA",
        STYLES: [
            {
                ID: "Territoire d’analyse (secondaire) anglophone, édition PQI",
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(168,0,0,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 7
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(168,0,0,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Territoire d’analyse (secondaire) anglophone, édition PQI 2026-2036",
            FEATURE_ID_DATACOLUMN : "CD_TA_SEC",
            FEATURE_NAME_DATACOLUMN : "CD_TA_SEC",
            DATATIP_DATACOLUMNS : "CD_TA_SEC",
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            //DATAVIEW_DATACOLUMNS : ["CD_TA_SEC", "CD_CS"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_TA_SEC", "CD_CS", "NB_PE"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_TA_SEC", "CD_CS"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "CD_TA_SEC",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false,
            BLEND_MODE : "NORMAL",
        }
    };
});
